export const sumAndSubstract = (number) => {
  let value;
  if (number.toString().includes('.')) {
    value = parseFloat(number.toFixed(10));
  } else {
    value = number;
  }
  return value;
};
export const formatNumber=(num)=>{

  const formattedNum = Number.parseFloat(num).toFixed(2);

  return formattedNum; 

}


export const maskString =(input)=>{

  const visibleDigits = 4;

  if (input.length <= visibleDigits) {
    return input;
  }
  
  const maskedLength = input.length - visibleDigits;
  const maskedPart = '*'.repeat(maskedLength);
  const visiblePart = input.slice(-visibleDigits);
  
  return maskedPart + visiblePart;

}





